import React from 'react';
import cn from 'classnames';
import styles from './PreHeading.module.scss';
const PreHeading = ({ Tag = 'p', className, children }) => (React.createElement(Tag, { className: cn(styles.general, className) }, children));
export default PreHeading;
//# sourceMappingURL=PreHeading.js.map